<template>
  <v-snackbar :value="showInstallMessage" timeout="-1" absolute top :style="{ zIndex: 20000 }">
    Install this webapp on your iPhone: tap <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#718AD6" viewBox="0 0 1000 1000"><path d="M780 290H640v35h140c19 0 35 16 35 35v560c0 19-16 35-35 35H220c-19 0-35-16-35-35V360c0-19 16-35 35-35h140v-35H220c-39 0-70 31-70 70v560c0 39 31 70 70 70h560c39 0 70-31 70-70V360c0-39-31-70-70-70zM373 180L483 70v553c0 9 7 17 17 17s18-8 18-17V70l110 110c3 3 7 5 12 5a17 17 0 0013-30L513 15c-7-7-18-7-25 0L348 155c-7 7-7 18 0 25s18 7 25 0z"/></svg> and then "Add to Home Screen"

    <template v-slot:action="{ attrs }">
      <v-btn
        text
        v-bind="attrs"
        @click="close"
      >
        <v-icon :style="{ color: defaultFontColor }">
          {{ mdiClose }}
        </v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mdiClose } from '@mdi/js';

export default {
  name: 'InstallPrompt',
  data() {
    return {
      showInstallMessage: false,
      mdiClose,
    };
  },
  mounted() {
    const isMessage = localStorage.getItem('hideInstallMessage');

    if (this.isIos() && !this.isInStandaloneMode() && !isMessage) {
      this.showInstallMessage = true;
    }
  },
  computed: {
    defaultFontColor() {
      return this.$store.getters['theme/theme'].common?.fontColor;
    },
  },
  methods: {
    close() {
      this.showInstallMessage = false;
      localStorage.setItem('hideInstallMessage', "true");
    },
    isIos() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test( userAgent );
    },
    isInStandaloneMode() {
      return ('standalone' in window.navigator) && (window.navigator.standalone);
    }
  }
};
</script>
